import { css } from 'styled-components';
export const rootMargin = '0px 0px -20% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-property: ${properties};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
export const fadeIn = () => {
    return {
        hidden: {
            opacity: 0,
            pointerEvents: 'none',
        },
        visible: {
            opacity: 1,
            transitionEnd: { pointerEvents: 'auto' },
        },
    };
};
export const horizontalFadeIn = (amount, duration) => {
    return {
        hidden: {
            opacity: 0,
            x: amount ?? 20,
        },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: duration ?? 0.35,
            },
        },
    };
};
export const verticalFadeIn = (amount, duration) => {
    return {
        hidden: {
            opacity: 0,
            y: amount ?? 20,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: duration ?? 0.35,
            },
        },
    };
};
